import script from "./messageadd.vue?vue&type=script&setup=true&lang=js"
export * from "./messageadd.vue?vue&type=script&setup=true&lang=js"

import "./messageadd.vue?vue&type=style&index=0&id=9e2a3528&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e2a3528"]])

export default __exports__